import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import MedicationEducationOptions from "./MedicationEducationOptions";
import MedicationEducationSearch from "./MedicationEducationSearch";
import VideoPlayer from "../common/videoPlayer";

export default class Service1340 extends Component {
  handleVideoFinished = (id) => {
    console.log("1340::handleVideoFinished() - Video %o finished!", id);
  };

  /**************
   * Properties *
   **************/

  /**
   * The service's different screens
   */
  bannerVisible = {
    visible: true,
  };
  searchButton = {
    id: "search",
    to: "search",
    unhighlight: require("./images/1340_btn_Search.png"),
    alt: "search",
  };
  watchVideoButton = {
    id: "watchVideo",
    to: "watchVideo",
    unhighlight: require("./images/1340_btn_SelectWatch.png"),
    alt: "watchVideo",
  };
  allNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/main_menu",
  };
  allButtons = [
    {
      id: "atgam",
      to: "atgam",
      highlight: require("./images/Medicine1_HL.png"),
      unhighlight: require("./images/Medicine1_UH.png"),
      alt: "ATGAM",
    },
    {
      id: "atgamSP",
      to: "atgam_sp",
      highlight: require("./images/Medicine2_HL.png"),
      unhighlight: require("./images/Medicine2_UH.png"),
      alt: "ATGAM - SP",
    },
    {
      id: "abilify",
      to: "abilify",
      highlight: require("./images/Medicine3_HL.png"),
      unhighlight: require("./images/Medicine3_UH.png"),
      alt: "Abilify",
    },
    {
      id: "abilifySP",
      to: "abilify_sp",
      highlight: require("./images/Medicine4_HL.png"),
      unhighlight: require("./images/Medicine4_UH.png"),
      alt: "Abilify - SP",
    },
    {
      id: "accuprilSP",
      to: "accupril_sp",
      highlight: require("./images/Medicine5_HL.png"),
      unhighlight: require("./images/Medicine5_UH.png"),
      alt: "Accupril - SP",
    },
  ];
  allHeader = {
    id: "header",
    src: require("./images/1340_elements.png"),
  };
  allButtonList = {
    top: 286,
    left: 195,
  };
  searchNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/medication_education",
  };
  searchHeader = {
    id: "header",
    src: require("./images/MedEd_Search.png"),
  };
  searchButtonList = {
    top: 180,
    left: 712,
  };
  searchButtons = [
    {
      id: "abilify",
      to: "abilify",
      highlight: require("./images/Abilify_HL.png"),
      unhighlight: require("./images/Abilify_UH.png"),
      alt: "Abilify",
    },
    {
      id: "abilifySP",
      to: "abilify_sp",
      highlight: require("./images/AbilifySP_HL.png"),
      unhighlight: require("./images/AbilifySP_UH.png"),
      alt: "Abilify",
    },
  ];
  searchButtonBlankList = {
    top: -6,
    left: -6,
  };
  searchButtonsBlank = [
    {
      id: "blank",
      to: "/medication_education/search_results",
      unhighlight: require("./images/MedEd_Search_Blank.png"),
      alt: "",
    },
  ];
  videoNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: null,
    doGoBack: true,
  };
  defaultVideo = {
    id: "default",
    src: require("./videos/254856HD_v2_ATGAM_MedEd.mp4"),
    onVideoEnded: this.handleVideoFinished,
  };
  atgam = Object.assign({}, this.defaultVideo, { id: "atgam" });
  atgamSP = Object.assign({}, this.defaultVideo, {
    id: "atgamSP",
    src: require("./videos/255626HD_v2_ATGAM-SP_MedEd.mp4"),
  });
  abilify = Object.assign({}, this.defaultVideo, { id: "abilify" });
  abilifySP = Object.assign({}, this.defaultVideo, {
    id: "healthyWaysPrepareFood",
    src: require("./videos/255626HD_v2_ATGAM-SP_MedEd.mp4"),
  });
  accuprilSP = Object.assign({}, this.defaultVideo, {
    id: "accuprilSP",
    src: require("./videos/255626HD_v2_ATGAM-SP_MedEd.mp4"),
  });

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1340">
        <Switch>
          <Route
            path="/medication_education/all"
            render={(routeProps) => (
              <MedicationEducationOptions
                {...routeProps}
                header={this.allHeader}
                banner={this.bannerVisible}
                navigationBar={this.allNavigationBar}
                imageButtonsList={this.allButtonList}
                imageButtons={this.allButtons}
                searchButton={this.searchButton}
                watchVideoButton={this.watchVideoButton}
              />
            )}
          />
          <Route
            path="/medication_education/atgam"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.atgam}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/medication_education/atgam_sp"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.atgamSP}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/medication_education/abilify"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.abilify}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/medication_education/abilify_sp"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.abilifySP}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/medication_education/accupril_sp"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.accuprilSP}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/medication_education/search_blank"
            render={(routeProps) => (
              <MedicationEducationSearch
                {...routeProps}
                banner={this.bannerVisible}
                navigationBar={this.searchNavigationBar}
                imageButtonsList={this.searchButtonBlankList}
                imageButtons={this.searchButtonsBlank}
                watchVideoButton={this.watchVideoButton}
              />
            )}
          />
          <Route
            path="/medication_education/search_results"
            render={(routeProps) => (
              <MedicationEducationSearch
                {...routeProps}
                header={this.searchHeader}
                text={this.textHeader}
                banner={this.bannerVisible}
                navigationBar={this.searchNavigationBar}
                imageButtonsList={this.searchButtonList}
                imageButtons={this.searchButtons}
                watchVideoButton={this.watchVideoButton}
              />
            )}
          />
          <Route
            path="/medication_education/search"
            render={() => <Redirect to="/medication_education/search_blank" />}
          />
          <Route
            path="/medication_education"
            render={() => <Redirect to="/medication_education/all" />}
          />
        </Switch>
      </div>
    );
  }
}
